export function vesselToSelect(vessels) {
    let cleanedVessels = [];

    vessels.map((item) => (
        cleanedVessels.push({
            label: item.name,
            value: item.id,
            item: item,
        })
    ));

    return cleanedVessels;
}


// WEBPACK FOOTER //
// ./src/utils/vessel.js